import SessionStorage from './client/api/session-storage';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Layout from './client/ui/layout/layout';
import { receivedAdmin } from './client/store/actions/user-actions';

import './style.scss';
import './App.css';

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ receivedAdmin }, dispatch);
};
const mapStateToProps = state => ({
  ...state,
});

class App extends Component {
  componentDidMount() {
    if (
      !this.props.userStore.admin.reg_id &&
      !this.props.userStore.admin.admin_id
    ) {
      const { receivedAdmin } = this.props;
      const admin = SessionStorage.getAdmin();
      receivedAdmin(admin);
    }
  }

  render() {
    return (
      <div className="App">
        <div>
          <Layout />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
